const UNSAFE_FILENAME = /[<>:"/\\|?*]/g;

export function safeFilename(name: string): string {
  const withoutControls = Array.from(name, (character) => character.charCodeAt(0) < 32 ? '_' : character).join('');
  const cleaned = withoutControls.replace(UNSAFE_FILENAME, '_').replace(/[. ]+$/g, '').trim();
  return (cleaned || 'recovered-file').slice(0, 180);
}

export function outputFilename(name: string, suffix: string, extension?: string): string {
  const safe = safeFilename(name);
  const dot = safe.lastIndexOf('.');
  const base = dot > 0 ? safe.slice(0, dot) : safe;
  const currentExtension = dot > 0 ? safe.slice(dot + 1) : '';
  const outputExtension = extension ?? currentExtension;
  return `${base}_${suffix}${outputExtension ? `.${outputExtension}` : ''}`;
}
